import { ClassificationsListComponent } from './classifications-list.component';

/**
 * 部門リストモデルクラス
 *
 * @export ClassificationsListModel
 * @class ClassificationsListModel
 */
export class ClassificationsListModel {

  /**
   * 部門情報リスト
   */
  public list: Array<any>;

  public classificationsList: ClassificationsListComponent;                     // リストインスタンス

  /**
   * 部門情報を更新する
   *
   * @param serverData 部門情報のサーバ取得データ
   */
  public updateList(serverData: any): void {
    // NULLチェック追加
    if (serverData == null) {
      this.list = new Array<any>();
      return;
    }

    const tempClassList: Array<any> = serverData;

    let index: number = <number>0;

    // コード+：+名称追加
    for (; index < tempClassList.length; index++) {
      tempClassList[index].ClassCodeName = [tempClassList[index].ClassCode + ':' + tempClassList[index].ClassName];
    }

    this.list = tempClassList;

    // 部門情報更新完了処理
    this.classificationsList.updateListComplete();
  }

}
